<template>
    <!-- 平台介绍 -->
    <div class="platformInfo">
          <div class="imgTitle">
            <img src="../../assets/img/jieshao.png" alt="图片不存在">
            <span>关于我们</span>
          </div>

          
          <img class="platformInfoImg" src="../../assets/img/xin2.png" alt="图片不存在">

          <div class="text">
            <p>
              2009年09月，山东省信用金桥中小企业发展服务有限公司(简称“信用金桥”)于山东省工商局注册成立。
              历经10余年，公司已成长为目前国内前沿的信用大数据服务提供商;
              是中国人民银行首批备案的企业征信机构，是国家发改委指定的首批可开展信用修复的企业征信机构，
              是国家工信部产融结合服务平台战略合作单位，是省工信厅委托的“山东省中小企业融资服务平台”管理运营机构，
              同时也是山东省中小企业协会副会长单位，山东省信用协会副会长单位。
            </p>
            <p>
              公司拥有超强企业信用信息数据库、五大服务功能模块以及系列信用服务产品，
              可随时为政府、金融/投资机构、行业协会、企业等提供相关信用服务。
            </p>
            <p>
              10余年磨砺，信用金桥始终坚持在信用信息采集、信用产品开发和应用领域深耕作;坚持让信用产生价值、用数据创造财富的服务理念;
              坚持以具体服务场景为导向，切准需求，创新开发设计服务产品和服务模式，力求精准服务，实现共赢。用数据创造财富。
            </p>
          </div>
          
    </div>

</template>

<script>
    export default{
        name:"PlatformInfo"
    }
</script>

<style scoped>
.platformInfo{
    width: 1920px;
    height: 560px;
    padding-left: 360px;
    padding-top: 72px;
    background: url("../../assets/img/jieshaobg.jpg") no-repeat;
    background-size: 100%;
    position: relative;
}

.platformInfo  .imgTitle{
    width: 1200px;
    padding-left: 10px;
    padding-top: 15px;
    padding-bottom:20px;
}
.platformInfo .imgTitle span{
    font-size: 25px;
    font-weight: 700;
    color: #ffffff;
    margin-left: 10px;   
}
.platformInfoImg{
    width: 481px;
    position: absolute;
    left: 1080px;
    top: 100px;
}
.platformInfo .text{
    width: 675px;
    height: 292px;
    font-size: 18px;
    color: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/PlatformInfo.vue